import { urlBaseAccreditation } from "../../config/";
import axiosInstance from "../../../services/config/axiosinstance";

export default async function getEventDoctorApi(eventId = '') {
  let message = ``;
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseAccreditation}/eventDoctor/eventDoctor?eventId=${eventId}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    if (_ret.data.data?.length > 0) {
      for (let i = 0; i < _ret.data.data.length; i++) {
        getMessage(_ret.data.data[i].data, _ret.data.data[i].message);
      }
    }

    return message;
  } catch (error) {
    console.log('Error getEventDoctorApi', error);
    throw error;
  }

  function getMessage(id = '', errorMessage = '') {
    let _text = '';

    switch (errorMessage) {
      case 'EVENT_WITHOUT_CONFIG':
        _text = `Evento sem configuração`;
        break;

      case 'EVENT_WITHOUT_SCHEDULE':
        _text = `Evento sem agenda`;
        break;

      case 'LABEL_ATTRIBUTE_NOT_EXISTS':
        _text = `Atributo de etiqueta "${id}" não existe`;
        break;

      case 'REGISTER_ATTRIBUTE_NOT_EXISTS':
        _text = `Atributo de cadastro "${id}" não existe`;
        break;

      case 'CONFIRMATION_ATTRIBUTE_NOT_EXISTS':
        _text = `Atributo de confirmação "${id}" não existe`;
        break;

      case 'BURN_QRCODE_SCHEDULE_NOT_EXISTS':
        _text = `Atributo de queima de QR Code "${id}" não existe`;
        break;

      case 'GUEST_IDENTIFIER_NOT_EXISTS':
        _text = `Identificador de participante "${id}" não existe`;
        break;

      case 'HTML_TERMS_INVALID':
        _text = `Termos de aceite com HTML inválido`;
        break;

      default:
        break;
    }

    if (_text) {
      message = message ? `${message}, \n${_text}` : _text;
    }
  }
}
